module.exports = __webpack_public_path__ + "static/media/referral-banner.ba3c75f0.jpg";